/* eslint-disable react-hooks/exhaustive-deps */
import { useRouter } from 'next/router'
import { RuleObject } from 'antd/lib/form'
import { useTranslation } from 'next-i18next'
import React, { useState, useEffect } from 'react'
import { rolType, UserRols } from 'src/core/models'
import { showNotification } from 'src/core/helpers'
import { Form, Row, Checkbox, Divider } from 'antd'
import { RegisterStateType } from 'src/core/models/auth.types'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { RegisterUserStepChanger, CustomCard, CustomTitle, CustomText, CustomCol } from 'src/components'
import {
  setUserhasCommercialCommunications,
  registerUserStateSelector,
  registerUserSelector,
  resetCreateUserState,
  resetRegisterState,
  setUserIsProducer,
  userRolsSelector,
  setUserIsWidget,
  registerNewUser,
  userRolSelector,
  setUserRols,
} from 'src/features'

const RolsForm: React.FC = () => {
  const router = useRouter()
  const [form] = Form.useForm()
  const dispatch = useAppDispatch()
  const { t, i18n } = useTranslation()
  const [terms, setTerms] = useState(false)
  const userType: rolType = useAppSelector(userRolSelector)
  const registerState: RegisterStateType = useAppSelector(registerUserStateSelector)
  const { isProducer, isWidget, hasCommercialCommunications } = useAppSelector(userRolsSelector)
  const { redirect } = router.query

  const {
    loading: loadingCreate,
    success: successCreate,
    error: errorCreate
  } = useAppSelector(registerUserSelector)

  const onFinish = () => {
    const values: UserRols = {
      isOffsetter: true,
      hasCommercialCommunications,
      isProducer,
      isWidget,
    }
    dispatch(setUserRols(values))
    dispatch(registerNewUser(registerState, i18n.language))
  }

  // eslint-disable-next-line no-unused-vars
  const validation = (rule: RuleObject, value: any, callback: (error?: string) => void) => {
    if (terms) {
      return callback()
    }
    return callback(t('general.RequiredValidation'))
  }

  useEffect(() => {
    if (errorCreate === 'ALREADY_EXIST') {
      showNotification('error', t('settings.EmailExistsError'))
      dispatch(resetCreateUserState())
    }
  }, [errorCreate])

  useEffect(() => {
    if (successCreate) {
      if (redirect && window && typeof redirect === 'string' ) {
        router.push('/auth/register-complete?redirect=' + redirect)
      } else {
        router.push(`/auth/register-complete?isProducer=${isProducer}`)
      }

      dispatch(resetRegisterState())
    }
  }, [successCreate])

  const handleComunicationsChange = (isChecked: boolean) => {
    if (isChecked && !terms) { setTerms(true) }
    dispatch(setUserhasCommercialCommunications(isChecked))
  }

  const termsURL = `/files/terms_${router.locale ==='es' ? 'es':'en'}.pdf`

  return (
    <div className='m-1'>
      <Form
        name='credentialsForm'
        onFinish={onFinish}
        autoComplete='off'
        className='mt-3'
        form={form}
      >
        <CustomCard>
          <CustomTitle label={t('Auth.Register.Rol')} type={null} />
          <CustomText label={t('Auth.Register.RolLabel')} type='secondary' />

          <Divider />
          <Row>
            <CustomCol lg={24}>
              {/* offsetter */}
              <Form.Item name='offsetter' valuePropName='offsetter'>
                <Checkbox disabled checked>
                  {t('Auth.Register.OffsetterLabel')}
                </Checkbox>
              </Form.Item>
            </CustomCol>
          </Row>

          {userType === 'COMPANY' && (
            <>
              <Row>
                <CustomCol lg={24}>
                  {/* Producer */}
                  <Form.Item name='producer' valuePropName='producer'>
                    <Checkbox checked={isProducer} onChange={(e) => {
                      dispatch(setUserIsProducer(e.target.checked))
                    }}>
                      {t('Auth.Register.ProducerLabel')}
                    </Checkbox>
                  </Form.Item>
                </CustomCol>
              </Row>

              <Row>
                <CustomCol lg={24}>
                  {/* Widget */}
                  <Form.Item name='widget' valuePropName='widget'>
                    <Checkbox checked={isWidget} onChange={(e) => {
                      dispatch(setUserIsWidget(e.target.checked))
                    }}>
                      {t('Auth.Register.WidgetLabel')}
                    </Checkbox>
                  </Form.Item>
                </CustomCol>
              </Row>
            </>
          )}

          <Divider />
          <Row>
            <CustomCol lg={24}>
              {/* Commercial Comunications */}
              <Form.Item name='commercialComunications' valuePropName='commercialComunications'>
                <Checkbox checked={hasCommercialCommunications} onChange={(e) => {
                  handleComunicationsChange(e.target.checked)
                }}>{t('Auth.Register.Consent')}
                </Checkbox>
              </Form.Item>
            </CustomCol>
          </Row>

          <Row>
            <CustomCol lg={24}>
              {/* TERMS */}
              <Form.Item name='terms' valuePropName='tems' rules={[{ validator: validation }]}>
                <Checkbox checked={terms} onChange={(e) => setTerms(e.target.checked)}>
                  <span dangerouslySetInnerHTML={{ __html: t('general.AcceptTermsLink',{ termsURL }) }} />
                </Checkbox>
              </Form.Item>
            </CustomCol>
          </Row>

        </CustomCard>
        <RegisterUserStepChanger nextStepValue={4} beforeStepValue={3} loading={loadingCreate} />
      </Form>
    </div>
  )
}

export default RolsForm
